import { render, staticRenderFns } from "./CardCeluleImunitare.vue?vue&type=template&id=25ac8e0c&scoped=true&"
import script from "./CardCeluleImunitare.vue?vue&type=script&lang=js&"
export * from "./CardCeluleImunitare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ac8e0c",
  null
  
)

export default component.exports